import script from "./VisiMisiSection.vue?vue&type=script&setup=true&lang=js"
export * from "./VisiMisiSection.vue?vue&type=script&setup=true&lang=js"

import "./VisiMisiSection.vue?vue&type=style&index=0&id=aa992418&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa992418"]])

export default __exports__